import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { RidAssessmentToast, RidMechanicBackground, RidMechanicContent, RidMechanicWrapper, RidTopBar } from '../../components';
import { delay } from '@gametailors/web-core/misc';
import { AudioEffectPlayer } from '../../utils/audio.utils';

export type MathOperation = 'add' | 'subtract' | 'multiply' | 'divide';

@Component({
  selector: 'rid-math',
  templateUrl: './rid-math.html',
  host: {
    class: 'block',
  },
  imports: [RidAssessmentToast, RidMechanicBackground, RidMechanicContent, RidMechanicWrapper, RidTopBar],
})
export class RidMath implements OnInit {
  exercises = input.required<[MathOperation, number, number][]>();
  visibilityDuration = input(3500);

  index = signal(0);
  exercise = computed(() => this.exercises()[this.index()]);
  operator = computed(() => {
    switch (this.exercise()[0]) {
      case 'add':
        return '+';
      case 'subtract':
        return '-';
      case 'multiply':
        return '×';
      case 'divide':
        return ':';
    }
  });
  answer = computed(() => {
    const exercise = this.exercise();
    switch (exercise[0]) {
      case 'add':
        return exercise[1] + exercise[2];
      case 'subtract':
        return exercise[1] - exercise[2];
      case 'multiply':
        return exercise[1] * exercise[2];
      case 'divide':
        return exercise[1] / exercise[2];
    }
  });
  state = signal<'VISIBLE' | 'ANSWER'>('VISIBLE');

  finished = output<void>();

  async ngOnInit() {
    await this.initialize();
  }

  async next() {
    const isLastIndex = this.index() === this.exercises().length - 1;

    if (isLastIndex) {
      this.finished.emit();
    } else {
      this.state.set('VISIBLE');
      this.index.set(this.index() + 1);
      await this.initialize();
    }
  }

  async initialize() {
    await delay(this.visibilityDuration());
    this.state.set('ANSWER');
  }

  markCorrect() {
    AudioEffectPlayer.play('CORRECT');
    return this.next();
  }

  markIncorrect() {
    AudioEffectPlayer.play('INCORRECT');
    return this.next();
  }
}
